import styled from 'styled-components';
import { transparentize } from 'polished';
import { withStyledSystem } from '@m/theme';
import type { StyledSystemProps } from '@m/theme';
import type { BannerProps } from './Banner';

type StyledBannerProps = StyledSystemProps & BannerProps;

export const BannerFixedBox = styled.div<StyledBannerProps>`
  position: fixed;
  top: ${({ placement }) => (placement === 'bottom' ? 'auto' : 0)};
  bottom: ${({ placement }) => (placement === 'bottom' ? 0 : 'auto')};
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: ${({ placement }) => (placement === 'bottom' ? 'flex-end' : 'flex-start')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  pointer-events: ${({ show }) => (show ? 'auto' : 'none')};
  transition: opacity 300ms linear 0ms;
  ${withStyledSystem}
`;

function getBannerTransform({
  placement,
  show,
}: StyledBannerProps) {
  if (show) {
    return '0';
  }
  if (placement === 'bottom') {
    return 'translate3d(0, 100%, 0)';
  }
  return 'translate3d(0, -100%, 0)';
}

export const BannerBox = styled.div<StyledBannerProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 60px;
  background-color: ${({ theme }) => transparentize(0.25, theme.colors.blue1)};
  backdrop-filter: blur(3px);
  transform: ${getBannerTransform};
  transition: transform 250ms ease 0ms;
  padding: 0 92px;
  pointer-events: inherit;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08),
              0 0 12px rgba(0, 0, 0, 0.08);
  ${withStyledSystem}
`;
